
import { Link } from "react-router-dom";
import { Map, LayoutDashboard } from "lucide-react";
import { navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { useAuth } from "@/context/AuthContext";

interface NavLinksProps {
  isMobile?: boolean;
  onMobileItemClick?: () => void;
  isDropdown?: boolean;
}

const NavLinks = ({ isMobile = false, onMobileItemClick, isDropdown = false }: NavLinksProps) => {
  const { user, userRole } = useAuth();
  
  const handleClick = () => {
    if (isMobile && onMobileItemClick) {
      onMobileItemClick();
    }
  };

  const linkClassName = isDropdown 
    ? "flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent rounded-md"
    : isMobile 
      ? "block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
      : navigationMenuTriggerStyle();

  return (
    <>
      {/* Show Crime Map to all users, but Dashboard only to vigilantes */}
      {(isDropdown || isMobile) && (
        <>
          {user && userRole === "vigilante" && (
            <li className={isDropdown ? "w-full" : ""}>
              <Link
                to="/dashboard"
                className={linkClassName}
                onClick={handleClick}
              >
                <LayoutDashboard className="h-4 w-4 mr-2" />
                Dashboard
              </Link>
            </li>
          )}
          <li className={isDropdown ? "w-full" : ""}>
            <Link
              to="/crime-map"
              className={linkClassName}
              onClick={handleClick}
            >
              <Map className="h-4 w-4 mr-2" />
              Crime Map
            </Link>
          </li>
        </>
      )}
    </>
  );
};

export default NavLinks;
